export default "__VITE_ASSET__lNwq9kCn__"